function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { isArray, isFunction } from '@cloud-sn/v-utils';
import { genCascaderKey } from '../utils';
export default {
  created: function created() {
    // no reactive
    this.cascaderStore = {
      nodesMap: {}
    };
  },
  methods: {
    createNodes: function createNodes() {
      var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var createNodes = this.createNodes,
          registerNode = this.registerNode,
          loadData = this.loadData,
          valueField = this.valueField,
          labelField = this.labelField,
          childrenField = this.childrenField;
      var ret = [];
      var l = nodes.length;

      if (l === 0) {
        return ret;
      }

      for (var i = 0; i < l; i += 1) {
        var node = nodes[i];

        if (node) {
          var value = node[valueField];
          var valuePath = parent ? [].concat(_toConsumableArray(parent.valuePath), [value]) : [value];

          var nNode = _objectSpread({}, node, {
            originNode: _objectSpread({}, node),
            parent: parent,
            level: level,
            valuePath: valuePath,
            value: value,
            label: node[labelField],
            children: node[childrenField],
            isLoading: false,
            isLoaded: false,
            isParent: isFunction(loadData) ? node.isParent !== false : false
          });

          var children = nNode.children;

          if (isArray(children) && children.length > 0) {
            nNode.children = createNodes(children, nNode, level + 1);
            nNode.isParent = true;
            nNode.isLoaded = true;
          }

          registerNode(nNode);
          ret.push(nNode);
        }
      }

      return ret;
    },
    clearNodesMap: function clearNodesMap() {
      var cascaderStore = this.cascaderStore;
      cascaderStore.nodesMap = {};
    },
    registerNode: function registerNode(node) {
      var nodesMap = this.cascaderStore.nodesMap;
      nodesMap[genCascaderKey(node.valuePath)] = node;
    },
    getNode: function getNode(valuePath) {
      var nodesMap = this.cascaderStore.nodesMap;
      return nodesMap[genCascaderKey(valuePath)];
    },
    addNodes: function addNodes() {
      var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parent = arguments.length > 1 ? arguments[1] : undefined;
      var createNodes = this.createNodes,
          childrenField = this.childrenField;
      var nNodes = nodes;

      if (!isArray(nNodes)) {
        nNodes = [nNodes];
      }

      var np = parent;
      var ret;

      if (np) {
        ret = createNodes(nNodes, np, np.level + 1);
        np.isParent = ret.length > 0;
        np.children = ret;
        np.originNode[childrenField] = ret.map(function (node) {
          return node.originNode;
        });
      } else {
        ret = createNodes(nNodes, null, 0);
      }

      return ret;
    }
  }
};